module.exports = __webpack_public_path__ + "media/images/page/q_ic-ccbc425344fb0c2bddac2e456eef5b32.svg";